import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Mail, KeyRound, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.toLowerCase().trim() });
      setSent(true);
    } catch (err) { toast.error("Falha"); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-12" data-testid="forgot-page">
      <Card className="p-6 rounded-2xl border-blue-200">
        <div className="flex items-center gap-2 text-blue-900 mb-2"><Mail size={24}/><h1 className="font-display text-2xl font-bold">Esqueci minha senha</h1></div>
        {sent ? (
          <div className="text-center py-6">
            <CheckCircle2 className="text-emerald-600 mx-auto mb-2" size={40}/>
            <p className="text-sm text-stone-700">Se o email existir em nossa base, você receberá um link em alguns instantes.</p>
            <Link to="/login" className="block mt-4 text-sm text-blue-700 hover:underline">Voltar ao login</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <p className="text-sm text-stone-600">Informe seu email e enviaremos um link para redefinir a senha.</p>
            <div><Label>Email</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-xl mt-1" data-testid="forgot-email"/></div>
            <Button type="submit" disabled={busy} className="w-full bg-blue-900 hover:bg-blue-950 text-white rounded-xl" data-testid="forgot-submit">
              {busy ? "Enviando..." : "Enviar link de redefinição"}
            </Button>
            <Link to="/login" className="block text-center text-xs text-stone-500 hover:underline">Voltar ao login</Link>
          </form>
        )}
      </Card>
    </div>
  );
}

export function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Mínimo 6 caracteres"); return; }
    if (password !== confirm) { toast.error("As senhas não coincidem"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Senha redefinida! Faça login.");
      navigate("/login");
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Token inválido ou expirado"); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-12" data-testid="reset-page">
      <Card className="p-6 rounded-2xl border-blue-200">
        <div className="flex items-center gap-2 text-blue-900 mb-2"><KeyRound size={24}/><h1 className="font-display text-2xl font-bold">Nova senha</h1></div>
        <form onSubmit={submit} className="space-y-3">
          <div><Label>Nova senha</Label><Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-xl mt-1" data-testid="reset-password"/></div>
          <div><Label>Confirme a nova senha</Label><Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="rounded-xl mt-1" data-testid="reset-confirm"/></div>
          <Button type="submit" disabled={busy} className="w-full bg-blue-900 hover:bg-blue-950 text-white rounded-xl" data-testid="reset-submit">
            {busy ? "Salvando..." : "Salvar nova senha"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
